<template>
  <div id="news-bg">
    <mt-loadmore :top-method="loadTop" ref="loadmore">
    <div v-if="!list.length&&canshow" class="nocontent">
        <span>还没有新闻公告哦~</span>
    </div>
    <div class="newscard" v-for="(item,index) in list" :key="index">
      <p class="time">{{item.publishDate}}</p>
      <div class="card-content" @click="godetail(item.itemId)">
        <div class="type-bg">
          <span class="card-type type-hot" v-if="item.type==1">紧急</span>
          <span class="card-type type-important" v-if="item.type==2">重要</span>
          <span class="card-type type-tip" v-if="item.type==3">提示</span>
          <span class="card-type type-info" v-if="item.type==4">通知</span>
          <span class="card-title">{{item.title}}</span>
        </div>
        <div class="img-bg">
          <img :src="item.wxBigImg" alt="">
        </div>
        <div class="content-bg">
          <p class="text">{{item.introText}}...</p>
        </div>
      </div>
    </div>
    <div class="more-bg" v-if="list.length">
        <span v-if="!allLoaded" @click="morelist">点击加载更多</span>
        <span v-else>就这么多了</span>
    </div>
    </mt-loadmore>
  </div>
</template>

<script>
import utils from '@/assets/script/utils.js';
import { Loadmore } from "mint-ui";
import { Toast } from 'mint-ui';
import qs from 'qs';
import axios from 'axios';
import $ from 'jquery';

export default {
  name: 'Content',
  data () {
    return {
      loading:false,
      allLoaded:false,
      list:[],
      nowpage:1,
      cookieb:'',
      canshow:false,
    }
  },
  methods:{
    getlist(){
    //  let obj={
    //     body:JSON.stringify({
    //     appDevice: {
    //       deviceId: "2.0.0_10000",
    //       OSVersion: "1.0.",
    //       qdDevice: "IphoneX",
    //       qdPlatform: "Ios",
    //       qdVersion: "6.0.1"
    //     },
    //     appUser: {
    //       curMemberId: "20180816182557365de",
    //       thirdId: "20180816182557365de"
    //     },
    //     pageNo: this.nowpage,
    //     pageSize: 10
    //   }), 
    //   }

      let obj={
        body:JSON.stringify({
        appDevice:{
          deviceId:this.cookieb.deviceId?this.cookieb.deviceId:'',
          OSVersion:this.cookieb.OSVersion?this.cookieb.OSVersion:'',
          qdDevice:this.cookieb.qdDevice?this.cookieb.qdDevice:'',
          qdPlatform:this.cookieb.qdPlatform?this.cookieb.qdPlatform:'',
          qdVersion:this.cookieb.qdVersion?this.cookieb.qdVersion:''
        },
        appUser:{
          curMemberId:this.cookieb.mId?this.cookieb.mId:'',
          thirdId:this.cookieb.aId?this.cookieb.aId:''
        },
        pageNo:1,
        pageSize:10
        }),
      }
      axios.post('/im/msgBox/publishMessageInfoList',qs.stringify(obj)).then((res)=>{
        if(res.data.code==200){
          this.list=res.data.data.messageInfoList;
          this.nowpage=res.data.data.pageNo;
          this.canshow=true;
        }else{
          Toast({
            message: "登录超时，请重新登录",
            position: 'bottom',
            duration: 5000
          });
        }
        
      })
      // this.$nextTick(()=> {
      //   this.scrollMode = "touch";
      // })
    },
    getmore(){
      //  let obj={
      //     body:JSON.stringify({
      //     appDevice: {
      //       deviceId: "2.0.0_10000",
      //       OSVersion: "1.0.",
      //       qdDevice: "IphoneX",
      //       qdPlatform: "Ios",
      //       qdVersion: "6.0.1"
      //     },
      //     appUser: {
      //       curMemberId: "20180816182557365de",
      //       thirdId: "20180816182557365de"
      //     },
      //     pageNo: this.nowpage,
      //     pageSize: 10
      //   }), 
      //   }

      let obj={
        body:JSON.stringify({
        appDevice:{
          deviceId:this.cookieb.deviceId?this.cookieb.deviceId:'',
          OSVersion:this.cookieb.OSVersion?this.cookieb.OSVersion:'',
          qdDevice:this.cookieb.qdDevice?this.cookieb.qdDevice:'',
          qdPlatform:this.cookieb.qdPlatform?this.cookieb.qdPlatform:'',
          qdVersion:this.cookieb.qdVersion?this.cookieb.qdVersion:''
        },
        appUser:{
          curMemberId:this.cookieb.mId?this.cookieb.mId:'',
          thirdId:this.cookieb.aId?this.cookieb.aId:''
        },
        pageNo:this.nowpage,
        pageSize:10
        }),
      }
      axios.post('/im/msgBox/publishMessageInfoList',qs.stringify(obj)).then((res)=>{
        if(res.data.data.messageInfoList.length){
          this.list.concat(res.data.data.messageInfoList)
          this.nowpage=res.data.data.pageNo;
        }else{
          this.allLoaded=true;
        }
        
      })
    },
    godetail(id){
      // this.sendmaidian('event_noticeMessage_Click','noticeMessageList');
      utils.go({ path: '/newsbulletin/newsbulletindetail', query: {id:id}}, this.$router);
    },
    morelist(){
      this.nowpage+=1;
      this.getmore();
    },
    loadTop(){
      this.allLoaded=false;
      this.$refs.loadmore.onTopLoaded();
      this.getlist();
    },
    getcookie(name){
        var that = this;　　　　
        //检查这个cookie是否存在，不存在就为 -1
        let c_start = document.cookie.indexOf(name + "=")
        if (c_start != -1) {
            //获取cookie值的开始位置
            c_start = c_start + name.length + 1;
            
            //通过";"号是否存在来判断结束位置
            let c_end = document.cookie.indexOf(";", c_start);

            if (c_end == -1){
                c_end = document.cookie.length;
            }
            //通过substring()得到了值
            this.cookieb = unescape(document.cookie.substring(c_start, c_end))
            this.cookieb=Base64.decode(this.cookieb)
            this.cookieb= JSON.parse(this.cookieb);
            
        }else{
          Toast({
            message: '请更新至最新版本',
            position: 'bottom',
            duration: 5000
          });
          
        }　　　　　　　　
    
    },
    sendmaidian(type,page){
      let obj1={
        AccountInfo: [],
        ApplicationInfo: [],
        BaseInfo: {
          LSE: 1,
          LV: "v3.2",
          AV: "1.1.0",
          UI: this.cookieb.mId?this.cookieb.mId:'', //用户id
          PJID: "" //社区id
          },
        NetworkInfo: [],
        PositionInfo: [],
        PageInfo: [{
          POT: new Date().getTime(),
          PCT: "",
          PI: page,
          AI: {
            platform_channel: "1"
          }
        }],
        EventInfo: [{
          EHT: new Date().getTime(),                    // 事件发生时间
          EI: type,  // 时间ID
          AI: {                                  // 额外参数
            PI: page,                // 所属页面
            platform_channel: "1"  
          }
        }]};
        let obj={}
        obj.body=JSON.stringify({logs:JSON.stringify(obj1)});
        $.ajax({
          type: "get",
          url: maidianurl,
          data: obj,
          success: function(data) {
            console.log(123);
          }
        })
    },
  },
  mounted:function(){
      document.title="新闻公告";
      this.getcookie('X');
      this.getlist();
      // this.sendmaidian('','noticeMessageList');
      
  }
}
</script>
    
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    /* #all-bg{
      overflow:scroll
    } */
    #news-bg{
      padding: 0 15px;
      min-height: 100vh;
      height: 100%;
      word-break:break-all;
      background: #F0F4F7;
    }
    #news-bg .newscard{
      margin-bottom: 10px;
    }
    #news-bg .newscard .time{
      font-size: 14px;
      color: #788596;
      letter-spacing: 0;
      padding: 10px 0;
      text-align: center;
    }
    #news-bg .newscard .card-content{
      /* height: 39vh; */
      background: #FFFFFF;
      border-radius: 4px;
      padding: 10px;
    }
    #news-bg .newscard .card-content .type-bg{
      height: 20px; 
      line-height: 20px;
    }
    #news-bg .newscard .card-content .card-type{
      display: inline-block;
      vertical-align:top;
      height: 20px;
      line-height: 20px;
      width: 6vh;
      text-align: center;
      border-radius: 2px;
      font-size: 14px;
      color: #FFFFFF;
    }
    #news-bg .newscard .card-content .card-title{
      vertical-align:top;
      height: 20px;
      line-height: 20px;
      display: inline-block;
      width: 70vw;
      font-size: 16px;
      color: #0B1D32;
      font-weight: 700;
      overflow: hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
    }
    .type-important{
      background: #0E9AC7;
    }
    .type-info{
      background: #FDBE25;
    }
    .type-tip{
      background: #F38501;
    }
    .type-hot{
      background: #9F98FB;
    }
    .img-bg{
      margin:2vh 0; 
      width: 100%;
      height: 20vh;
    }
    .img-bg img{
      width: 100%;
      height: 100%;
    }
    .content-bg{
      display: inline-block;
      width: 100%;
      font-size: 14px;
      /* max-height: 9vh; */
      max-height: 62px;
      /* overflow: hidden; */
    }
    .content-bg .text{
      display: inline-block;
      font-size: 14px;
      max-height: 62px;
      width: 100%;
      /* overflow-y:hidden; */
      /* text-overflow:ellipsis; */
      /* white-space:nowrap; */
    }
    #news-bg .nocontent{
      height: 100vh;
      padding-top: 20px;
      text-align: center;
    }
    #news-bg .more-bg{
      margin-top: 20px;
      margin-bottom: 10px;
      text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/views/news/list.vue